import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { ThemeProvider } from './ui/context/theme/ThemeProvider';
import router from './config/router';

import './index.css'
import { GlobalProvider } from './ui/context/global/GlobalProvider';
import { LoaderProvider } from './ui/context/loader/LoaderProvider';
import { NotificationProvider } from './ui/context/notification/NotificationContext';

ReactDOM.createRoot(document.getElementById("root")).render(
  <ThemeProvider>
    <GlobalProvider>
      <LoaderProvider>
        <NotificationProvider>
          <RouterProvider router={router}/>
        </NotificationProvider>
      </LoaderProvider>
    </GlobalProvider>
  </ThemeProvider>
)

//<RouterProvider router={routes}/>`